module.exports = __webpack_public_path__ + "img/5.52b1a25d.jpg";